/*
  © 2022 KondaSoft.com
  https://www.kondasoft.com
*/

var ig_free_gift;
var intelligems_active = false;

window.addEventListener('ig:ready', () => {
  const campaigns = window.igData?.campaigns.getAll();
  if (campaigns.length){
    intelligems_active = true;
    ig_free_gift = campaigns[0].discount.tiers[0].giftWithPurchaseVariantId;
  }
});

setTimeout(function(){
  if( $('.free_gift_bar').length && intelligems_active == true ){
    $('.free_gift_bar:not(.free_delivery) .content > .inner, .free_gift_bar:not(.free_delivery) .content > p').addClass('d-none')
  }
}, 500);

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async () => {
  const offcanvasCart = document.querySelector('#offcanvas-cart')
  const cartBadges = document.querySelectorAll('.cart-badge')


  const cartSummary = document.querySelector('#template-cart-summary')
  const cart_body = document.querySelector('#template-cart form.cart')
  const freegift_progress = document.querySelector('#template-cart .section_holder')

  offcanvasCart?.classList.add('loading')
  cart_body?.querySelector('.products').classList.add('loading')

  const respoonse = await fetch(window.location.href)
  const data = await respoonse.text()
  const parser = new DOMParser()
  const newDocument = parser.parseFromString(data, 'text/html')

  offcanvasCart?.querySelector('.offcanvas-body')
    .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
  offcanvasCart?.querySelector('.offcanvas-footer')
    .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))

  // if on cart page and your emptying contents
  if( newDocument.querySelector('#template-cart-summary .card-body') == null && document.body.classList.contains('page-type-cart')){
    window.location = '/cart';
  } else{

    freegift_progress?.querySelector('.free_gift_bar')
      .replaceWith(newDocument.querySelector('#template-cart .section_holder .free_gift_bar'))
    cartSummary?.querySelector('.card-body')
      .replaceWith(newDocument.querySelector('#template-cart-summary .card-body'))
    cart_body?.querySelector('.products')
      .replaceWith(newDocument.querySelector('#template-cart form.cart .products'))
  }

  if(window.Rebuy){
    console.log('rebuy is active');
    Rebuy.init();
  }

  cartBadges.forEach((badge) => {
    badge.style.display = 'block'
    badge.textContent = newDocument.querySelector('.cart-badge').textContent
  })

  offcanvasCart?.classList.remove('loading')
  cart_body?.querySelector('.products').classList.remove('loading')

  // intelligems stuff
  // if( $('.add_single').length && intelligems_active == true ){
  //   var $btn = $('.add_single.btn');
  //   $btn.attr('freegift_id', ig_free_gift);
  // }

  if( $('.free_gift_bar').length && intelligems_active == true ){
    $('.free_gift_bar:not(.free_delivery) .content > .inner, .free_gift_bar:not(.free_delivery) .content > p').addClass('d-none')
  }

  if( $('#free_gift_selection').length ){
    $('#free_gift_selection .content').addClass('d-none');
    var variant_count = parseInt($('#free_gift_selection .content[data-handle="'+ shop_config.free_gift_handle +'"]').data('variants'));

    if(variant_count > 1){
      $('#free_gift_selection .content[data-handle="'+ shop_config.free_gift_handle +'"]').removeClass('d-none');
      $('#openpopup').removeClass('d-none');
      $('.add_single.btn').addClass('d-none');
    } else{
      $('#openpopup').addClass('d-none');
      $('.add_single.btn').removeClass('d-none').attr('freegift_id', ig_free_gift);
    }
  }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
  let key = input.dataset.lineItemKey;
  let items = {'updates': {} };

  let value = input.value;
  if( input.dataset.type == 'remove' ){
    value = 0;

    if( input.dataset.freegift_key ){
      var cart_minus = parseInt(input.dataset.cart_minus);
      var gift_min = parseInt(input.dataset.gift_min);

      if( cart_minus < gift_min ){
        key = key + ','+ input.dataset.freegift_key;
      }
    }
  }

  if( key.includes(',') ){
    const split_key = key.split(',');
    split_key.forEach(function(elem){ items['updates'][parseInt(elem)] = value; });
  } else{
    items['updates'][parseInt(key)] = value;
  }
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(items)
  })
  window.refreshCartContents()
}

document.addEventListener('rebuy.add', function(event){
  window.refreshCartContents()
}); 

// Checkout button - indicate loading on click
window.onCheckoutBtnClick = (btn) => {
  // btn.style.height = btn.clientHeight + 'px'
  // btn.innerHTML = `
  //   <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
  //       <span class="visually-hidden">Loading...</span>
  //   </div>
  // `
}

// Offcanvas cart - open it with direct url (hash based)
if (window.location.hash.includes('#cart') && document.querySelector('#offcanvas-cart')) {
  bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
}
